import React, { useEffect, useRef, useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import CheckedInvoiceSummary from "./CheckedInvoiceSummary";
import PaymentSelection from "./PaymentSelection";
import { TabPanel } from "react-tabs";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllBillingDetails,
  manageBillingSelector,
  ProcessCCPayment,
  ProcessCCPaymentForPayCheckedInvoice,
} from "../../features/managebilling/manageBillingSlice";
import {
  invoiceSelector,
  setdiffCCDetails,
  setisAllCCVaultKeysfetched,
  setPayInoviceCCDetails,
} from "../../features/invoice/invoiceSlice";
import { useForm } from "react-hook-form";
import { IsObjectNotEmpty } from "../../common/utils";
import { ToastContainer, toast } from "react-toastify";
import {
  orderSliceSelector,
  updateWSrequestLog,
} from "../../features/orders/orderSlice";
import { authLoginSelector } from "../../features/auth/authLoginSlice";
import Loader from "../orderStatus/Loader";
import PaymentSucessPopup from "./PaymentSucessPopup";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const PayCheckedInvoices = ({
  selectedOutstandingInvoices,
  setspayCheckedInvoices,
  isLawyer,
  setshowOutstanding,
  firmID,
}) => {
  console.log("🚀 ~ selectedOutstandingInvoices:", selectedOutstandingInvoices);
  const [selectedInvoices, setSelectedInvoices] = useState(
    selectedOutstandingInvoices,
  );

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    trigger,
    control,
    watch,
    formState: { errors },
  } = useForm();
  const [invoiceTotal, setInvoiceTotal] = useState(0);
  const [showPaymentMethodForm, setShowPaymentMethodForm] = useState([]);

  const uniquePaymentTypes = [];
  const [altPaymentReq, setAltPaymentReq] = useState(true);
  const [PaymentSuccessPopup, setPaymentSuccessPopup] = useState(false);
  const [partialFailurePopup, setPartialFailurePopup] = useState(false);
  const {
    billingDetails,
    PayCheckedInvoiceResponse,
    loading,
    allBillingDetails,
  } = useSelector(manageBillingSelector);

  const { WSRequestlogID } = useSelector(orderSliceSelector);
  const { userLogin } = useSelector(authLoginSelector);

  const calculateTaxPercentage = (subtotal, tax) => {
    const subtotalNum = parseFloat(subtotal?.replace(/[^0-9.]/g, ""));
    const taxNum = parseFloat(
      tax?.replace(/[^0-9.]/g, "").replace(/^/, tax?.includes("-") ? "-" : ""),
    );
    if (subtotalNum === 0) return 0;
    else {
      return ((taxNum / subtotalNum) * 100).toFixed(2);
    }
  };

  useEffect(() => {
    if (allBillingDetails.length === 0) {
      dispatch(
        GetAllBillingDetails(
          firmID,
          selectedOutstandingInvoices,
          userLogin?.userId,
        ),
      );
    }
  }, [allBillingDetails]);

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const values = getValues();
  console.log("🚀 ~ billingDetails:", billingDetails);
  const [totalPaymentAttempts, setTotalPaymentAttempts] = useState(0);

  const {
    paymentInfoValue,
    diffCCDetails,
    PayInoviceCCDetails,
    isAllCCVaultKeysfetched,
  } = useSelector(invoiceSelector);
  console.log("🚀 ~ paymentInfoValue:", paymentInfoValue);
  console.log("FINAL TRANSACTION RESULTS: ", PayCheckedInvoiceResponse);
  console.log("TOTAL PAYMENT ATTEMPTS: ", totalPaymentAttempts);

  const calculateInvoiceTotal = (item) => {
    let subTotal = 0;
    let tax = 0;

    selectedInvoices.map((invoice) => {
      if (invoice.original.cardNumber === item) {
        subTotal += parseFloat(
          invoice.original.invoiceSubtotal?.replace(/[^0-9.]/g, ""),
        );
        tax += parseFloat(
          invoice.original.invoiceTax
            ?.replace(/[^0-9.]/g, "")
            .replace(
              /^/,
              invoice.original.invoiceTax?.includes("-") ? "-" : "",
            ),
        );
      }
    });

    return (subTotal + tax).toFixed(2);
  };

  const calculateGrandTotal = () => {
    let subTotal = 0;
    let tax = 0;

    selectedInvoices.forEach((invoice) => {
      const invoiceID = invoice.original.invoiceID;
      if (
        PayCheckedInvoiceResponse &&
        PayCheckedInvoiceResponse?.length > 0 &&
        PayCheckedInvoiceResponse?.length === totalPaymentAttempts
      ) {
        const paymentStatus = PayCheckedInvoiceResponse?.find(
          (resp) => resp.InvoiceID == invoiceID,
        );

        if (!paymentStatus?.isSuccess) {
          subTotal += parseFloat(
            invoice.original.invoiceSubtotal?.replace(/[^0-9.]/g, "") || "0",
          );
          tax += parseFloat(
            invoice.original.invoiceTax
              ?.replace(/[^0-9.]/g, "")
              .replace(
                /^/,
                invoice.original.invoiceTax?.includes("-") ? "-" : "",
              ) || "0",
          );
        }
      } else {
        subTotal += parseFloat(
          invoice.original.invoiceSubtotal?.replace(/[^0-9.]/g, ""),
        );
        tax += parseFloat(
          invoice.original.invoiceTax
            ?.replace(/[^0-9.]/g, "")
            .replace(
              /^/,
              invoice.original.invoiceTax?.includes("-") ? "-" : "",
            ),
        );
      }
    });
    console.log("🚀 ~ calculateGrandTotal ~ subTotal:", subTotal);
    return (subTotal + tax).toFixed(2);
  };

  selectedInvoices.map((item) => {
    if (
      item.original.cardNumber &&
      !uniquePaymentTypes.includes(item.original.cardNumber)
    ) {
      uniquePaymentTypes.push(item.original.cardNumber);
    }
  });

  const lawyerInvoiceTotal = 0;
  const [eftPaymentReq, setEftPaymentReq] = useState(
    uniquePaymentTypes.includes("EFT") ? true : false,
  );
  const [chequePaymentReq, setChequePaymentReq] = useState(
    uniquePaymentTypes.includes("Cheque") ? true : false,
  );

  const [IFrameCount, setIFrameCount] = useState(0);
  const [finalCCArray, setfinalCCArray] = useState([]);
  const [diffCCToken, setdiffCCToken] = useState([]);
  const [ccErrors, setccErrors] = useState([]);
  const iframeRef = useRef([]);

  let ccTokens = [];
  let ccError = [];

  const ccTokensRef = useRef([]);
  let ccTokenCount = 0; // Stores tokens with their index
  const expectedTokenCount = useRef(0); // Number of iframes to expect
  const getIframeIndexFromEvent = (e) => {
    return iframeRef.current.findIndex(
      (iframe) => iframe?.contentWindow === e.source,
    );
  };

  const handleMonerisResponse = React.useCallback(
    async (e) => {
      try {
        const respData = JSON.parse(e.data);
        const responseCode = Array.isArray(respData.responseCode)
          ? respData.responseCode[0]
          : respData.responseCode;
        const iframeIndex = getIframeIndexFromEvent(e);
        const paymentType =
          uniquePaymentTypes?.[iframeIndex] ?? `idx_${iframeIndex}`;
        if (responseCode === "001") {
          const tokenObj = {
            cardIndex: respData.id,
            cardId: respData?.bin,
            token: respData?.dataKey,
          };
          console.log(
            "🚀 ~ handleMonerisResponse ~ tokenObj.respData?.dataKey:",
            respData?.dataKey,
          );

          ccTokens.push({
            cardIndex: respData.id,
            cardId: respData?.bin,
            token: respData?.dataKey,
          });

          // setdiffCCToken([...diffCCToken,respData?.dataKey]);
          dispatch(setdiffCCDetails(respData?.dataKey));

          //  fillEmptyValues(finalCCArray,respData?.dataKey);
          ccTokensRef.current[respData.dataKey] = tokenObj;
          ccTokenCount += 1;
          console.log(`Token received for index ${respData.id}:`, tokenObj);

          const receivedCount = ccTokenCount;
          if (receivedCount === expectedTokenCount.current) {
            console.log("All tokens received!");

            const finalTokensArray = [];
            let ccTokenIndex = 0;

            for (let j = 0; j < paymentInfoValue?.length; j++) {
              if (Object.keys(paymentInfoValue[j])?.length > 0) {
                finalTokensArray.push(paymentInfoValue[j]);
              } else {
                if (ccTokenIndex < ccTokens.length) {
                  finalTokensArray.push(ccTokens[ccTokenIndex]);
                  ccTokenIndex++;
                } else {
                  console.warn("Not enough ccTokens for empty entries");
                }
              }
            }
            console.log("FINAL TOKENS ARRAY", finalTokensArray);
            console.log("Final Tokens Array:", finalTokensArray);
          }
        } else {
          setccErrors((prev) => ({
            ...prev,
            [paymentType]: {
              code: respData?.responseCode,
              message: respData?.errorMessage ?? "Payment error",
            },
          }));
        }
      } catch (err) {
        console.error("Error parsing Moneris response:", err);
      }
    },
    [dispatch, paymentInfoValue, diffCCDetails, setccErrors],
  );

  const PayAllCheckedInvoices = async () => {
    dispatch(setdiffCCDetails("empty"));
    dispatch(setPayInoviceCCDetails("empty"));
    dispatch(setisAllCCVaultKeysfetched(false));
    ccTokensRef.current = [];
    setccErrors([]);
    // setmultiCCTokens([]);
    // setfinalCCArray([]);

    const count = uniquePaymentTypes?.length;
    const entriesNeedingTokens = paymentInfoValue?.filter(
      (entry) => Object.keys(entry)?.length === 0,
    );
    expectedTokenCount.current = entriesNeedingTokens?.length;
    console.log("🚀 ~ PayAllCheckedInvoices ~ values:", values);
    let temparray = [];

    if (count > 0) {
      for (let i = 0; i < count; i++) {
        const delay = 2000;
        const iframe = iframeRef.current[i];
        if (iframe !== undefined) {
          console.log(`🚀 Sending tokenize message to iframe ${i}`);
          setIFrameCount(i + 1);
          temparray[i] = { vaultDataKey: null };
          // dispatch(setPayInoviceCCDetails({vaultDataKey:null}));

          await postMessageWithDelay(iframe, "tokenize", delay, i);
        } else {
          //dispatch(setPayInoviceCCDetails({vaultDataKey:values[`paymentInfoDropdown_${i}`]?.vaultDataKey}));
          if (values[`paymentInfoDropdown_${i}`]?.vaultDataKey !== undefined) {
            temparray[i] = {
              vaultDataKey: values[`paymentInfoDropdown_${i}`]?.vaultDataKey,
            };
          }
        }
      }
      // setfinalCCArray([]);
      // setfinalCCArray(temparray);
      dispatch(setPayInoviceCCDetails(temparray));
    }
    console.log("🚀 ~ PayAllCheckedInvoices ~ filledArray:", finalCCArray);
  };

  function areAllValuesNotEmpty(arr) {
    try {
      var result = arr.every(
        (value) =>
          value.vaultDataKey !== null &&
          value.vaultDataKey !== undefined &&
          value.vaultDataKey !== "",
      );
      return result;
    } catch (error) {
      console.log("areAllValuesNotEmpty error : ", error);
    }
  }

  function fillEmptyValues(array1, array2) {
    try {
      let filledArray = [];

      let array2Index = 0;
      for (let i = 0; i < array1.length; i++) {
        if (
          !IsObjectNotEmpty(array1[i].vaultDataKey) &&
          array2Index < array2.length
        ) {
          filledArray[i] = { vaultDataKey: array2[array2Index] };
          array2Index++;
        } else {
          filledArray[i] = { vaultDataKey: array1[i].vaultDataKey };
        }
      }
      dispatch(setPayInoviceCCDetails(filledArray));
    } catch (error) {
      console.log("fillEmptyValues error : ", error);
    }
  }

  console.log("🚀 ~ setIFrameCount:", IFrameCount);
  console.log("🚀 ~ PayInoviceCCDetails:", PayInoviceCCDetails);

  useEffect(() => {
    console.log("🚀 ~ useEffect ~ diffCCDetails:", diffCCDetails);
    console.log("🚀 ~ useEffect ~ PayInoviceCCDetails:", PayInoviceCCDetails);
    if (
      PayInoviceCCDetails !== null &&
      PayInoviceCCDetails.length > 0 &&
      isAllCCVaultKeysfetched === false
    ) {
      // var filledArray=fillEmptyValues(PayInoviceCCDetails,diffCCDetails);
      if (
        diffCCDetails !== null &&
        diffCCDetails.length > 0 &&
        diffCCDetails?.length === IFrameCount &&
        PayInoviceCCDetails?.length === uniquePaymentTypes?.length &&
        !areAllValuesNotEmpty(PayInoviceCCDetails)
      ) {
        fillEmptyValues(PayInoviceCCDetails, diffCCDetails);
      }
      if (
        PayInoviceCCDetails?.length === uniquePaymentTypes?.length &&
        areAllValuesNotEmpty(PayInoviceCCDetails)
      ) {
        dispatch(setisAllCCVaultKeysfetched(true));
      }
    }
  }, [PayInoviceCCDetails, diffCCDetails]);

  useEffect(() => {
    console.log(
      "🚀 ~ useEffect ~ isAllCCVaultKeysfetched:",
      isAllCCVaultKeysfetched,
    );
    if (isAllCCVaultKeysfetched && areAllValuesNotEmpty(PayInoviceCCDetails)) {
      var updatedCCdetails = [];
      uniquePaymentTypes.map((item, index) => {
        var containerFields = selectedInvoices.filter(
          (invoice) => invoice.original.cardNumber === item,
        );
        var fileIds = containerFields
          .map((item) => item.original.fileID)
          .join("|");
        var filenumbers = containerFields
          .map((item) => item.original.fileNumber)
          .join("|");
        var invoiceIds = containerFields
          .map((item) => item.original.invoiceID)
          .join("|");
        var dealtypeID = containerFields[0].original.dealTypeID;
        var lawyerID = containerFields[0].original.lawyerID;
        var invoiceTotal = containerFields.reduce((acc, item) => {
          const value = parseFloat(
            item.original.invoiceTotal.replace(/[^0-9.]/g, ""),
          );
          return acc + (isNaN(value) ? 0 : value);
        }, 0);

        updatedCCdetails[index] = {
          vaultDataKey: PayInoviceCCDetails[index]?.vaultDataKey,
          fileIDs: fileIds,
          filenumbers: filenumbers,
          invoiceIds: invoiceIds,
          dealtypeID: dealtypeID,
          lawyerID: lawyerID,
          invoiceTotal: invoiceTotal,
        };
      });
      console.log(
        "🚀 ~ uniquePaymentTypes.map ~ updatedCCdetails:",
        updatedCCdetails,
      );
      setTotalPaymentAttempts(updatedCCdetails?.length);
      for (let i = 0; i < updatedCCdetails?.length; i++) {
        var request = {
          transactionID: 0,
          fileID: updatedCCdetails[i]?.fileIDs,
          FileNumber: updatedCCdetails[i]?.filenumbers,
          invoiceIds: updatedCCdetails[i]?.invoiceIds,
          dealTypeID: updatedCCdetails[i]?.dealtypeID,
          invoiceTotal: updatedCCdetails[i]?.invoiceTotal.toString(),
          lawyerID: updatedCCdetails[i]?.lawyerID,
          CCTransactionLogIds: "",
          hostedToken: updatedCCdetails[i]?.vaultDataKey,
          IssuerID: "",
          defaultNewCC: false,
          sourceApp: 1,
          userID: userLogin?.userId,
        };
        dispatch(
          ProcessCCPaymentForPayCheckedInvoice(request, userLogin?.userId, {
            toast,
          }),
        );
      }
    }
  }, [isAllCCVaultKeysfetched, PayInoviceCCDetails]);

  // function updateExtraDetailsForCheckedInvoices(PayInoviceCCDetails)
  // {
  //   var updatedCCdetails=[]
  //   uniquePaymentTypes.map((item, index) => {
  //     var containerFields= selectedInvoices.filter(
  //        (invoice) => invoice.original.billingType === item

  //      );
  //      var fileIds=containerFields.map(item=>item.original.fileID).join("|");
  //      var invoiceIds=containerFields.map(item=>item.original.invoiceID).join("|");
  //      var dealtypeID=containerFields[0].dealTypeID;
  //      var lawyerID=containerFields[0].lawyerID;
  //      var invoiceTotal = containerFields.reduce((acc, item) => {
  //        const value = parseFloat(item.original.invoiceTotal.replace(/[^0-9.]/g, ""));
  //        return acc + (isNaN(value) ? 0 : value);
  //      }, 0);

  //       updatedCCdetails[index]={
  //         vaultDataKey:PayInoviceCCDetails[index].PayInoviceCCDetails,
  //         fileIDs:fileIds,
  //         invoiceIds:invoiceIds,
  //         dealtypeID:dealtypeID,
  //         lawyerID:lawyerID,
  //         invoiceTotal:invoiceTotal
  //        }

  //    });
  //  console.log("🚀 ~ uniquePaymentTypes.map ~ updatedCCdetails:", updatedCCdetails);
  //    dispatch(setPayInoviceCCDetails(updatedCCdetails));
  // }

  useEffect(() => {
    if (PayCheckedInvoiceResponse !== null) {
      console.log(
        "🚀 ~ useEffect ~ PayCheckedInvoiceResponse:",
        PayCheckedInvoiceResponse,
      );
      if (WSRequestlogID !== 0) {
        dispatch(
          updateWSrequestLog(
            WSRequestlogID,
            fileID,
            JSON.stringify(PayCheckedInvoiceResponse),
            "PaymentLocation-Pay Checked Invoices",
            "",
            "ProcessCCPayment",
            PayCheckedInvoiceResponse.transactionID.toString(),
            userLogin?.userId,
          ),
        );
      }
      if (
        PayCheckedInvoiceResponse &&
        PayCheckedInvoiceResponse?.length > 0 &&
        PayCheckedInvoiceResponse?.length === totalPaymentAttempts &&
        PayCheckedInvoiceResponse?.some((invoice) => invoice?.isSuccess) &&
        !PayCheckedInvoiceResponse?.some((invoice) => !invoice?.isSuccess)
      ) {
        setPaymentSuccessPopup(true);
      }
      if (
        PayCheckedInvoiceResponse &&
        PayCheckedInvoiceResponse?.length > 0 &&
        PayCheckedInvoiceResponse?.length === totalPaymentAttempts &&
        // PayCheckedInvoiceResponse?.some((invoice) => invoice?.isSuccess) &&
        PayCheckedInvoiceResponse?.some((invoice) => !invoice?.isSuccess)
      ) {
        setPartialFailurePopup(true);
      }
    }
  }, [PayCheckedInvoiceResponse, WSRequestlogID]);

  useEffect(() => {
    window.addEventListener("message", handleMonerisResponse);
    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("message", handleMonerisResponse);
    };
  }, [handleMonerisResponse]);

  const postMessageWithDelay = (iframe, message, delay, index) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        //const messageWithId = JSON.stringify({ action: message, id: index });
        const data = iframe?.contentWindow?.postMessage(
          message,
          process.env.REACT_APP_HOSTED_URL,
        );
        // console.log("Response:", data);
        resolve(data);
      }, delay);
    });
  };
  console.log(
    "PayCheckedInvoiceResponse",
    PayCheckedInvoiceResponse?.filter(
      (response) => response.transactionID && response.isSuccess,
    ),
  );
  return (
    <div>
      <ToastContainer />
      {PaymentSuccessPopup && !partialFailurePopup && (
        <PaymentSucessPopup
          setPaymentSuccessPopup={setPaymentSuccessPopup}
          PayCheckedInvoiceResponse={PayCheckedInvoiceResponse}
          transactionIDs={PayCheckedInvoiceResponse?.filter(
            (response) => response.isSuccess,
          )
            .map((invoice) => invoice.transactionID)
            ?.join(",")}
          setshowOutstanding={setshowOutstanding}
          t={t}
        />
      )}
      {partialFailurePopup && !PaymentSuccessPopup && (
        <div
          className="fixed inset-0 z-40 flex items-center justify-center px-4"
          style={{ background: "#0000004D" }}
        >
          <div
            className="relative flex flex-col bg-white rounded-[4px] shadow-lg"
            style={{
              width: "600px",
              minHeight: "190px",
              padding: "45px",
            }}
          >
            <div className="flex items-center gap-[10px] mb-[18px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                  stroke="#E2211C"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="12"
                  y1="9"
                  x2="12"
                  y2="13"
                  stroke="#E2211C"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <line
                  x1="12"
                  y1="17"
                  x2="12.01"
                  y2="17"
                  stroke="#E2211C"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>

              <h3
                className="text-[20px] leading-[24px] font-[700] text-[#231F20]"
                style={{ fontFamily: "Montserrat, sans-serif" }}
              >
                Attention
              </h3>
            </div>

            <p
              className="text-[16px] leading-[24px] font-[400] text-[#231F20] mb-[40px]"
              style={{ fontFamily: "Open Sans, sans-serif", maxWidth: "500px" }}
            >
              {
                PayCheckedInvoiceResponse?.filter(
                  (invoice) => !invoice?.isSuccess
                )?.length || 0
              }{" "}
              of {PayCheckedInvoiceResponse?.length || 0} payment(s) failed. Please
              change payment method and try again.
            </p>

            <div className="flex items-center justify-between mt-auto">
              <button
                type="button"
                className="flex items-center gap-[6px] text-[16px] leading-[24px] font-[600] text-[#526D7D] whitespace-nowrap"
                style={{ fontFamily: "Open Sans, sans-serif" }}
                onClick={() => setPartialFailurePopup(false)}
              >
                View Payment Confirmation
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m9 18 6-6-6-6"
                    stroke="#526D7D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              <button
                type="button"
                className="flex items-center justify-center h-[44px] min-w-[198px] px-[24px] rounded-[2px] text-[16px] leading-[24px] font-[600] text-[#231F20] whitespace-nowrap"
                style={{
                  fontFamily: "Montserrat, sans-serif",
                  background: "#FFCD34",
                  paddingTop: 8,
                  paddingBottom: 8,
                }}
                onClick={() => setPartialFailurePopup(false)}
              >
                Update payment method
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-between mb-[30px]">
        <div className="flex flex-wrap font-[400] font-open-sans gap-[15px] leading-[22px] text-[#526D7D] text-[16px]">
          <div>
            {t("MakeaPayment")}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="14"
              fill="none"
              className="inline ml-[10px]"
            >
              <path
                d="m1.308 12.922 5.384-5.923-5.384-5.923"
                stroke="#A09F9F"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <Link to="/orderstatus?tab=3" state={{ Tab: 4, SubTab: 1 }}>
            <button
              onClick={() => {
                // setspayCheckedInvoices(false);
                setTimeout(() => window.location.reload(), 200);
              }}
            >
              {t("OutstandingInvoices")}
              <item
                src="images/steper-icon.73b7cd71.svg"
                aria-hidden="true"
                className="inline ml-[10px]"
                alt="steper icon"
              />
            </button>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="14"
              fill="none"
              className="inline ml-[10px]"
            >
              <path
                d="m1.308 12.922 5.384-5.923-5.384-5.923"
                stroke="#A09F9F"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Link>
          <div className="font-[600] text-[#231F20]">
            {t("PayCheckedInvoices")}
          </div>
        </div>
        <Link to="/orderstatus?tab=3" state={{ Tab: 4, SubTab: 1 }}>
          <button
            className="flex focus:bg-[#F8F8F8] font-semibold h-[40px] hover:bg-[#F8F8F8] outline-neutrals-black px-4 py-2 rounded-sm"
            onClick={() => {
              // setspayCheckedInvoices(false);
              setTimeout(() => window.location.reload(), 200);
            }}
          >
            <item
              aria-hidden="true"
              className="h-[12px] mr-4 mt-[6px] w-[12px]"
              src="../../arrow-left.e8cef756.svg"
              alt="back arrow"
            />
            {"< "} Back
          </button>
        </Link>
      </div>
      <div className="flex gap-[16px]">
        <div className="flex flex-col gap-[17px]" style={{ flexGrow: 1 }}>
          {uniquePaymentTypes.map((item, index) => {
            return (
              <Accordion
                allowMultipleExpanded
                allowZeroExpanded
                className="!px-[0px] custom__accordion full overflow-auto w-[880px]"
                style={{
                  marginBottom: "15px",
                  borderColor: item.includes("EFT")
                    ? eftPaymentReq
                      ? "#E2211C"
                      : "black"
                    : item.includes("Cheque")
                      ? chequePaymentReq
                        ? "#E2211C"
                        : "black"
                      : "black",
                }}
              >
                <AccordionItem>
                  <div id="accordion-property-heading-1" className="px-[40px]">
                    <div
                      className="flex justify-between"
                      style={{ fontFamily: "Montserrat,sans-serif" }}
                    >
                      <AccordionItemButton className="bg-white custom__accordion-header p-5 w-full">
                        <svg
                          aria-hidden="true"
                          width="28"
                          height="28"
                          fill="none"
                          style={{ positon: "relative", zIndex: 9999 }}
                        >
                          <path
                            d="m7 10.5 7 7 7-7"
                            stroke="#231F20"
                            stroke-width="3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span
                          className="!font-[600] !text-[18px]"
                          style={{ width: "fitContent", float: "left" }}
                        >
                          {!isLawyer &&
                            (function () {
                              const uniqueLawyers = {};
                              const lawyerNames = selectedInvoices
                                .filter(
                                  (invoice) =>
                                    invoice.original.cardNumber === item,
                                )
                                .map((invoice) => invoice.original.lawyerName)
                                .filter((lawyerName) => {
                                  if (!uniqueLawyers[lawyerName]) {
                                    uniqueLawyers[lawyerName] = true;
                                    return true;
                                  }
                                  return false;
                                });

                              return lawyerNames.map((lawyerName, index) => (
                                <React.Fragment key={index}>
                                  {lawyerName}
                                  {index !== lawyerNames.length - 1
                                    ? " + "
                                    : " "}
                                </React.Fragment>
                              ));
                            })()}

                          {!isLawyer &&
                            (selectedInvoices.filter(
                              (invoice) => invoice.original.cardNumber === item,
                            ).length > 1
                              ? "Invoices - "
                              : "Invoice - ")}
                          {` ${
                            // item?.replace(/payment/i, "").trim().length >= 18
                            //   ? `${item
                            //       ?.replace(/payment/i, "")
                            //       .trim()
                            //       .slice(0, 18)}.... ${item
                            //       ?.replace(/payment/i, "")
                            //       .trim()
                            //       .slice(-4)}`
                            //   :
                            item?.replace(/\s*payment/i, "").trim()
                          }`}
                        </span>
                        {item.includes("EFT") ? (
                          eftPaymentReq ? (
                            <div
                              id="alternative_error"
                              className="ml-[20px] text-[#E2211C]"
                              style={{ fontFamily: "Montserrat,sans-serif" }}
                            >
                              {" "}
                              Alternative payment method required{" "}
                            </div>
                          ) : (
                            <></>
                          )
                        ) : item.includes("Cheque") ? (
                          chequePaymentReq ? (
                            <div
                              id="alternative_error"
                              className="ml-[20px] text-[#E2211C]"
                              style={{ fontFamily: "Montserrat,sans-serif" }}
                            >
                              {" "}
                              Alternative payment method required{" "}
                            </div>
                          ) : (
                            <></>
                          )
                        ) : (
                          <></>
                        )}

                        {/* <div className="col-3"> */}

                        {/* </div> */}
                      </AccordionItemButton>
                      <b>
                        {PayCheckedInvoiceResponse &&
                          PayCheckedInvoiceResponse?.length > 0 &&
                          PayCheckedInvoiceResponse?.length ===
                            totalPaymentAttempts &&
                          (PayCheckedInvoiceResponse?.filter((resp) =>
                            resp.InvoiceID?.includes(
                              selectedInvoices?.filter(
                                (invoice) =>
                                  invoice.original.cardNumber === item,
                              )[0]?.original.invoiceID,
                            ),
                          )[0]?.isSuccess
                            ? "✅ Payment completed successfully"
                            : "❌ Payment failed")}
                      </b>
                      <button
                        type="button"
                        className="block font-[600] font-open-sans leading-[19.07px] px-[10px] text-[#526D7D] text-[14px] w-[110px]"
                        onClick={() => {
                          setSelectedInvoices(
                            selectedInvoices.filter(
                              (invoice) => invoice.original.cardNumber != item,
                            ),
                          );
                          if (item.includes("EFT")) {
                            setEftPaymentReq(false);
                          } else if (item.includes("Cheque")) {
                            setChequePaymentReq(false);
                          }
                        }}
                      >
                        Remove all
                      </button>
                    </div>
                  </div>
                  <AccordionItemPanel>
                    <div
                      id="accordion-property-body-1"
                      className="h-full max-h-[850px]"
                      aria-labelledby="accordion-property-heading-1"
                    >
                      <PaymentSelection
                        defaultMethod={item?.replace(/\s*payment/i, "").trim()}
                        paymentMethod={item}
                        values={selectedOutstandingInvoices.original}
                        setAltPaymentReq={(val) => setAltPaymentReq(val)}
                        setEftPaymentReq={(val) => setEftPaymentReq(val)}
                        setChequePaymentReq={(val) => setChequePaymentReq(val)}
                        t={t}
                        paymentInformation={() => {
                          const lawyerIDs = selectedInvoices
                            ?.filter(
                              (invoice) => invoice.original.cardNumber === item,
                            )
                            ?.map((item) => item.original.lawyerID); // your target lawyerIDs
                          const selectedBillingDetails = lawyerIDs
                            .map((id) => allBillingDetails[id])
                            .filter(Boolean); // remove undefined in case some IDs don't exist
                          // return lawyerIDs?.length > 1
                          //   ?
                          return selectedBillingDetails
                            ?.flatMap((detail) =>
                              detail.paymentInformation?.map((payment) => ({
                                ...payment,
                                paymentMethod: payment.paymentMethod
                                  ?.replace(/\s*payment/i, "")

                                  .trim(),
                              })),
                            )
                            ?.filter((payment) =>
                              payment.paymentMethod?.includes("Credit Card"),
                            );
                        }}
                        iframeRef={iframeRef}
                        CCerror={ccErrors}
                        index={index}
                        uniquePaymentTypes={uniquePaymentTypes}
                        control={control}
                        formvalues={values}
                        setValue={setValue}
                        setfinalCCArray={setfinalCCArray}
                        diffCCDetails={diffCCDetails}
                        showPaymentMethodForm={showPaymentMethodForm}
                        setShowPaymentMethodForm={setShowPaymentMethodForm}
                        trigger={trigger}
                        allBillingDetails={allBillingDetails}
                      />
                      <div className="border-[#d9d9d9] border-t-[1px] flex flex-col font-open-sans mt-[32px] rounded-[2px]">
                        <div className="bg-[#FFF9EA] flex flex-row font-[600] leading-[21.79px] px-[32px] py-[14px] text-[16px] w-full">
                          <div className="w-[55%]">
                            Invoices (
                            {
                              selectedInvoices.filter(
                                (invoice) =>
                                  invoice.original.cardNumber === item,
                              ).length
                            }
                            )
                          </div>
                          <div className="text-end w-[13%]">Deal Type</div>
                          <div className="text-end w-[18%]">Closing Date</div>
                          <div className="text-end w-[12%]">Net Due</div>
                        </div>
                        {selectedInvoices
                          .filter(
                            (invoice) => invoice.original.cardNumber === item,
                          )
                          .map((x, index) => {
                            return (
                              <CheckedInvoiceSummary
                                invoice={x}
                                selectedInvoices={selectedInvoices}
                                setSelectedInvoices={(data) =>
                                  setSelectedInvoices(data)
                                }
                                paymentType={item}
                                setEftPaymentReq={(val) =>
                                  setEftPaymentReq(val)
                                }
                                setChequePaymentReq={(val) =>
                                  setChequePaymentReq(val)
                                }
                              />
                            );
                          })}
                      </div>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>
              </Accordion>
            );
          })}{" "}
        </div>
        <div
          className="bg-[#F8F8F8] h-fit max-h-[1000px] p-[24px] w-[436px]"
          style={{ marginBottom: "25px", float: "right" }}
        >
          <div
            className="block font-semibold leading-[21px] mb-[32px] text-[18px]"
            style={{ fontFamily: "Montserrat,sans-serif" }}
          >
            Payment Summary
          </div>
          <button
            id="pay_invoices_button"
            className="btn__primary font-[600] h-[40px] leading-[21.79px] px-[16px] text-[#231F20] text-[16px] text-center w-full"
            style={{
              fontFamily: "Montserrat,sans-serif",
            }}
            disabled={
              uniquePaymentTypes?.length === 0 ||
              eftPaymentReq ||
              chequePaymentReq
            }
            onClick={() => {
              PayAllCheckedInvoices();
            }}
          >
            Pay Invoices
          </button>
          {(eftPaymentReq || chequePaymentReq) && (
            <div
              className="font-[400] font-open-sans leading-[21px] mt-[8px] text-[#E2211C] text-[16px] text-start w-full"
              id="missing_payment_summary"
            >
              Payment method missing
            </div>
          )}
          <div className="font-[600] font-open-sans leading-[24px] mt-[5px] text-[18px] text-end w-full">
            {selectedInvoices.length} Invoices
          </div>
          <div className="form-container mt-[20px]">
            {uniquePaymentTypes.map((item, index) => {
              return (
                <div className="!border-none !p-[0px] custom__tab-content mb-4">
                  <div
                    id="payment__1-content"
                    role="tabpanel"
                    aria-labelledby="payment_1"
                  >
                    <Accordion allowMultipleExpanded allowZeroExpanded>
                      <AccordionItem className="custom__accordion simple">
                        <>
                          <AccordionItemHeading>
                            <AccordionItemButton className="!bg-transparent !font-[600] !pb-[0px] !pt-[0px] custom__accordion-header text-[16px] w-full">
                              {showPaymentMethodForm &&
                              showPaymentMethodForm?.length > 0 &&
                              showPaymentMethodForm?.some((obj) =>
                                item.toLowerCase().includes("credit card")
                                  ? item.match(/\d+\*+\d+/)?.[0] ===
                                      Object.keys(obj)[0].match(
                                        /\d+\*+\d+/,
                                      )?.[0] && obj[Object.keys(obj)[0]]
                                  : Object.keys(obj)[0] === item &&
                                    obj[Object.keys(obj)[0]],
                              )
                                ? "Credit Card"
                                : paymentInfoValue?.length > 0 &&
                                    paymentInfoValue[index] &&
                                    typeof paymentInfoValue[index] ===
                                      "object" &&
                                    Object.keys(paymentInfoValue[index])
                                      ?.length > 0
                                  ? `${paymentInfoValue[index]?.paymentMethod} ${paymentInfoValue[index]?.maskedCardNumber}`
                                  : item}
                              <svg
                                aria-hidden="true"
                                className="h-6 shrink-0 w-6"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M5.293 7.293a1 1 0 0 1 1.414 0L10 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                            </AccordionItemButton>
                          </AccordionItemHeading>
                          <hr className="border-line-thick mb-[12px] mt-[8px] w-full" />
                          <AccordionItemPanel>
                            <div className="!border-none !p-[0px] custom__tab-content mb-4">
                              {selectedInvoices
                                .filter(
                                  (invoice) =>
                                    invoice.original.cardNumber === item,
                                )
                                .map((x, index) => {
                                  return (
                                    <>
                                      <div className="custom__accordion-panel-wrapper">
                                        <div className="flex font-[400] font-open-sans justify-between leading-[21px] text-[16px]">
                                          <div>
                                            {x.original.lawyerName} Subtotal
                                          </div>
                                          <div>
                                            {x.original.invoiceSubtotal}
                                          </div>
                                        </div>
                                        <div className="flex font-[400] font-open-sans justify-between leading-[21px] mt-[8px] text-[16px]">
                                          <div>{`Tax (${calculateTaxPercentage(
                                            x.original.invoiceSubtotal,
                                            x.original.invoiceTax,
                                          )}%)`}</div>
                                          <div>{x.original.invoiceTax}</div>
                                        </div>
                                      </div>
                                      <hr className="border-line-thick mb-[12px] mt-[8px] w-full" />
                                    </>
                                  );
                                })}
                            </div>
                            {/* <hr className="border-line-thick mb-[12px] mt-[8px] w-full" /> */}
                          </AccordionItemPanel>
                        </>
                      </AccordionItem>
                    </Accordion>
                  </div>
                  <div
                    className="flex font-[600] font-open-sans justify-between leading-[21px] text-[16px]"
                    style={{ marginBottom: "-15px", marginTop: "-5px" }}
                  >
                    <div>Total</div>
                    <div>${calculateInvoiceTotal(item)}</div>
                  </div>
                </div>
              );
            })}
            <div className="mt-[64px]">
              <hr className="border-line-thick mb-[18px] w-full" />
              <div className="flex font-[700] font-open-sans justify-between leading-[30px] text-[22px]">
                <div>Total</div>
                <div>${calculateGrandTotal()}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <dialog
        id="processing_payment_dialog"
        className="!bg-[#FFFFFFA7] bottom-0 fixed flex h-full hidden inset-x-0 px-4 sm:inset-0 sm:items-center sm:justify-center w-full z-40"
        style={{ background: "#0000001a" }}
        open={loading}
      >
        <div className="!pt-[26.17px] bg-white flex flex-col gap-[10px] h-[155px] items-center justify-center overflow-hidden p-[48] relative rounded shadow-none w-[616px]">
          <div>
            <svg className="spinner" width="50" height="50">
              <circle
                cx="25"
                cy="25"
                r="20"
                stroke="#D9D9D9"
                stroke-width="7"
                fill="none"
              />
              <circle
                cx="25"
                cy="25"
                r="20"
                stroke="#FFCD34"
                stroke-width="7"
                fill="none"
                stroke-dasharray="31.42 94.25"
              />
            </svg>
          </div>
          <h3 className="font-[400] font-open-sans leading-[25px] text-[#000000] text-[18px]">
            We’re processing your payment please wait
          </h3>
        </div>
      </dialog>
      {loading ? <Loader /> : ""}
    </div>
  );
};

export default PayCheckedInvoices;
